import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

export const useSavedLanesCTAStyles = makeStyles(theme => ({
  root: {
    backgroundColor: brandColors.skyBlue0,
    padding: '24px',
  },
  text: {
    marginBottom: theme.spacing(1),
  },
  button: {
    color: brandColors.skyBlue6,
    backgroundColor: brandColors.skyBlue0,
    borderColor: brandColors.skyBlue6,
  },
  savedLaneImage: {
    width: '120px',
  },
}))
